<template>
    <el-form ref="goodsReportForm" :model="goodsReportForm" label-width="70px" style="margin-right: 10prx;">
        <el-form-item label="英文名称" style="margin-bottom: 0;width: 100%;" ref="goodNameEnglish">
            <el-input v-model="goodsReportForm.goodNameEnglish" maxlength="60" 
                        @focus="focusFormItem('英文名称')"
                        @change="goodsRecognize('goodNameEnglish')"
                        >
            </el-input>
            <el-popover
                placement="bottom"
                width="300"
                trigger="manual"
                v-model="goodsRecoPop.goodNameEnglish">
                <goods-reco-comp ref="goodNameEnglishReco" :setting="recoSetting" curField="goodNameEnglish"></goods-reco-comp>
                <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                    <el-button @click="goodsRecoPop.goodNameEnglish = false">取消</el-button>
                    <el-button @click="getRecognizedData('goodNameEnglish')">确定</el-button>
                </div>
            </el-popover>            
        </el-form-item> 
        <el-row>
            <el-col :span="16">
                <el-form-item label="中文名称" style="margin-bottom: 0;" ref="goodNameChinese">
                    <el-input v-model="goodsReportForm.goodNameChinese" maxlength="60" 
                        @focus="focusFormItem('中文名称')"
                        @change="goodsRecognize('goodNameChinese')">
                        <!-- <el-button slot="append" style="color:#3975C6;font-size: 16px;" icon="el-icon-s-grid" @click="btnUnrulyGoodsClick"></el-button> -->
                    </el-input>
                </el-form-item>
                <el-popover
                    placement="bottom"
                    width="300"
                    trigger="manual"
                    v-model="goodsRecoPop.goodNameChinese">
                    <goods-reco-comp ref="goodNameChineseReco" :setting="recoSetting" curField="goodNameChinese"></goods-reco-comp>
                    <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                        <el-button @click="goodsRecoPop.goodNameChinese = false">取消</el-button>
                        <el-button @click="getRecognizedData('goodNameChinese')">确定</el-button>
                    </div>
                </el-popover>                                          
            </el-col>
            <el-col :span="8">
                <el-form-item label="单位" style="margin-bottom: 0;" ref="unit">
                    <el-input v-model="goodsReportForm.unit" maxlength="10" 
                        @focus="focusFormItem('单位')">
                    </el-input>
                </el-form-item>                        
            </el-col>                                        
        </el-row>                   
        <el-row>
            <el-col :span="8">
                <el-form-item label="数量" style="margin-bottom: 0;" ref="number">
                    <el-input type="number" v-model.number="goodsReportForm.number" 
                        @focus="focusFormItem('数量')"
                        @change="numberPriceChanged">
                    </el-input>
                </el-form-item>                        
            </el-col>
            <el-col :span="8">
                <el-form-item label="单价" style="margin-bottom: 0;" ref="price">
                    <el-input type="number" v-model="goodsReportForm.price" :class="!numberCheck()?'numberInput':'numberInputBlack'" 
                            @focus="focusFormItem('单价')"
                            @change="numberPriceChanged">
                    </el-input>
                    <!-- <el-input-number v-model="goodsReportForm.price" :controls="false" :class="!numberCheck()?'numberInput':'numberInputBlack'" style="width: 100%;" @change="numberPriceChanged" ></el-input-number> -->
                </el-form-item>                        
            </el-col>
            <el-col :span="8">
                <el-form-item label="总价" style="margin-bottom: 0;" ref="totalPrice">
                    <el-input type="number" v-model.number="goodsReportForm.totalPrice" 
                        @focus="focusFormItem('总价')">
                    </el-input>
                </el-form-item>                        
            </el-col>                                        
        </el-row>
        <el-row>
            <el-col :span="14">
                <el-form-item label="材质" style="margin-bottom: 0;" ref="material">
                    <el-input v-model="goodsReportForm.materialEnglish" maxlength="60" 
                        @focus="focusFormItem('英文材质')"
                        @change="goodsRecognize('materialEnglish')">
                    </el-input>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="manual"
                        v-model="goodsRecoPop.materialEnglish">
                        <goods-reco-comp ref="materialEnglishReco" :setting="recoSetting" curField="materialEnglish"></goods-reco-comp>
                        <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                            <el-button @click="goodsRecoPop.materialEnglish = false">取消</el-button>
                            <el-button @click="getRecognizedData('materialEnglish')">确定</el-button>
                        </div>
                    </el-popover>                                     
                </el-form-item>                        
            </el-col>
            <el-col :span="10">
                <el-input v-model="goodsReportForm.materialChinese" maxlength="60" placeholder="中文材质" 
                    @focus="focusFormItem('中文材质')"
                    @change="goodsRecognize('materialChinese')">
                </el-input>
                <el-popover
                    placement="bottom"
                    width="300"
                    trigger="manual"
                    v-model="goodsRecoPop.materialChinese">
                    <goods-reco-comp ref="materialChineseReco" :setting="recoSetting" curField="materialChinese"></goods-reco-comp>
                    <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                        <el-button @click="goodsRecoPop.materialChinese = false">取消</el-button>
                        <el-button @click="getRecognizedData('materialChinese')">确定</el-button>
                    </div>
                </el-popover>                   
            </el-col>
        </el-row> 
        <el-row>
            <el-col :span="14">
                <el-form-item label="用途" style="margin-bottom: 0;" ref="purpose">
                    <el-input v-model="goodsReportForm.purposeEnglish" maxlength="60" 
                        @focus="focusFormItem('英文用途')"
                        @change="goodsRecognize('purposeEnglish')">
                    </el-input>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="manual"
                        v-model="goodsRecoPop.purposeEnglish">
                        <goods-reco-comp ref="purposeEnglishReco" :setting="recoSetting" curField="purposeEnglish"></goods-reco-comp>
                        <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                            <el-button @click="goodsRecoPop.purposeEnglish = false">取消</el-button>
                            <el-button @click="getRecognizedData('purposeEnglish')">确定</el-button>
                        </div>
                    </el-popover>                    
                </el-form-item>                        
            </el-col>
            <el-col :span="10">
                <el-input v-model="goodsReportForm.purposeChinese" maxlength="60" placeholder="中文用途" 
                    @focus="focusFormItem('中文用途')"
                    @change="goodsRecognize('purposeChinese')">
                </el-input>
                <el-popover
                    placement="bottom"
                    width="300"
                    trigger="manual"
                    v-model="goodsRecoPop.purposeChinese">
                    <goods-reco-comp ref="purposeChineseReco" :setting="recoSetting" curField="purposeChinese"></goods-reco-comp>
                    <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                        <el-button @click="goodsRecoPop.purposeChinese = false">取消</el-button>
                        <el-button @click="getRecognizedData('purposeChinese')">确定</el-button>
                    </div>
                </el-popover>                   
            </el-col>            
        </el-row>
        <el-row>
            <el-col :span="14">
                <el-form-item label="商品编码" style="margin-bottom: 0;" ref="hsGoodCode">
                    <el-input v-model="goodsReportForm.hsGoodCode" maxlength="35" show-word-limit 
                        @focus="focusFormItem('商品编码')"
                        @change="goodsRecognize('hsGoodCode')">
                    </el-input>
                    <el-popover
                        placement="bottom"
                        width="300"
                        trigger="manual"
                        v-model="goodsRecoPop.hsGoodCode">
                        <goods-reco-comp ref="hsGoodCodeReco" :setting="recoSetting" curField="hsGoodCode"></goods-reco-comp>
                        <div style="display: flex;  flex-direction:row; justify-content:flex-end; margin-top: 10px;">
                            <el-button @click="goodsRecoPop.hsGoodCode = false">取消</el-button>
                            <el-button type="primary" @click="getRecognizedData('hsGoodCode')">确定</el-button>
                        </div>
                    </el-popover>                    
                </el-form-item>                                        
            </el-col>
            <el-col :span="9" style="display: flex;justify-content:space-around;">
                <el-button type="text" size="mini" style="margin-left: 20px;" @click="btnSaveDetailClick">{{goodsReportForm.index==-1?'保存':'修改'}}</el-button>                                          
                <el-button type="text" size="mini" @click="btnCancelDetailClick">取消</el-button>   
                <el-button type="text" size="mini" @click="btnSaveAsDetailClick">另存</el-button>                     
            </el-col>                                                                                           
        </el-row>
        <div v-if="unrulyGoods" style="color:red;">
            {{unrulyGoods.keyword + ":" + unrulyGoods.warning}}
        </div>
        <el-dialog
          title="识别申报为运费"
          :visible.sync="freightFeeDialogVisible">
          <div style="margin: 0px 20px;">
            <div>英文名称: FREIGHT FEE</div>
            <div>数量: 1</div>
            <div>材质: .</div>
            <div>用途: .</div>
            <div>商品编码: 1000000000</div>
          </div>
          <span slot="footer" class="dialog-footer">
            <el-button @click="freightFeeDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="freightFeeDialogConfirm">确 定</el-button>
          </span>
        </el-dialog>        
    </el-form>
</template>

<script>
import * as string from '@/utils/string'
import goodsRecoComp from './goods-reco-comp.vue'
import _ from 'lodash'
export default {
    props: {
        goodsReport: {
            type: Object
        },
        unrulyGoodsList: {
            type: Array
        },
        recoSetting:{
            type: Object
        }
    },
	watch: {
        goodsReport(value){ 
            if(value != null){
                this.goodsReportForm = {...value}
            }else{
                this.initGoodsReport()
            }
            if(this.goodsReportForm.goodNameChinese){
                this.unrulyGoods = this.checkUnrulyGoods(this.goodsReportForm.goodNameChinese)
            }
        },
        unrulyGoodsList(value){
            if(this.goodsReportForm.goodsNameChinese){
                this.unrulyGoods = this.checkUnrulyGoods(this.goodsReportForm.goodNameChinese)
            }
        }
    },
    mounted(){
        window['fillDetailData'] = (data)=>{
            let p = data.indexOf(':')
            let value = data.substr(p + 1)
            if(data.startsWith('英文名称:')){
                if(this.goodsReportForm.goodNameEnglish){
                    this.goodsReportForm.goodNameEnglish = this.goodsReportForm.goodNameEnglish + ' ' + value
                }else{
                    this.goodsReportForm.goodNameEnglish = value
                }
                this.goodsRecognize('goodNameEnglish')
            }else
            if(data.startsWith('中文名称:')){
                if(this.goodsReportForm.goodNameChinese){
                    this.goodsReportForm.goodNameChinese = this.goodsReportForm.goodNameChinese + ' ' + value
                }else{
                    this.goodsReportForm.goodNameChinese = value
                }
            }else            
            if(data.startsWith('单位:')){
                this.goodsReportForm.unit = value
            }else
            if(data.startsWith('数量:')){
                this.goodsReportForm.number = value.replace(/[^0-9]/g,"")
                this.numberPriceChanged()
            }else
            if(data.startsWith('单价:')){
                this.goodsReportForm.price = value.replace(/[^0-9|.]/g,"")    
                this.numberPriceChanged()                          
            }else
            if(data.startsWith('总价:')){
                this.goodsReportForm.totalPrice = value.replace(/[^0-9|.]/g,"")            
            }else
            if(data.startsWith('英文材质:')){
                if(this.goodsReportForm.materialEnglish){
                    this.goodsReportForm.materialEnglish = this.goodsReportForm.materialEnglish + ' ' + value
                }else{
                    this.goodsReportForm.materialEnglish = value
                }          
                this.goodsRecognize('materialEnglish')                
            }else         
            if(data.startsWith('英文用途:')){
                if(this.goodsReportForm.purposeEnglish){
                    this.goodsReportForm.purposeEnglish = this.goodsReportForm.purposeEnglish + ' ' + value
                }else{
                    this.goodsReportForm.purposeEnglish = value
                }          
                this.goodsRecognize('purposeEnglish')                
            }else        
            if(data.startsWith('中文材质:')){
                if(this.goodsReportForm.materialChinsese){
                    this.goodsReportForm.materialChinsese = this.goodsReportForm.materialChinsese + ' ' + value
                }else{
                    this.goodsReportForm.materialChinsese = value
                }            
                this.goodsRecognize('materialChinsese')                
            }else         
            if(data.startsWith('中文用途:')){
                if(this.goodsReportForm.purposeChinese){
                    this.$set(this.goodsReportForm, 'purposeChinese', this.goodsReportForm.purposeChinese + ' ' + value)
                }else{
                    this.$set(this.goodsReportForm, 'purposeChinese', value)
                }                  
                this.goodsRecognize('purposeChinese')                
            }else  
            if(data.startsWith('商品编码:')){
                this.goodsReportForm.hsGoodCode = value                
                this.goodsRecognize('hsGoodCode')                
            }            
        }        
        this.initGoodsReport()
    },    
    data() {
        return { 
            goodsReportForm:{},
            unrulyGoods: null,
            goodsRecoPop:{
                goodNameEnglish: false,
                goodNameChinese: false,                
                materialEnglish: false,
                purposeEnglish: false,
                hsGoodCode: false,
                materialChinese: false,
                purposeChinese: false                
            },
            freightFeeDialogVisible: false
        }
    },
    methods:{
        initGoodsReport(){
            this.$set(this.goodsReportForm, 'index', -1)            
            this.$set(this.goodsReportForm, 'goodNameEnglish', '')
            this.$set(this.goodsReportForm, 'goodNameChinese', '')
            this.$set(this.goodsReportForm, 'unit', 'PCS')
            this.$set(this.goodsReportForm, 'number','')
            this.$set(this.goodsReportForm, 'price','')
            this.$set(this.goodsReportForm, 'totalPrice', '')
            this.$set(this.goodsReportForm, 'hsGoodCode', '')
            this.$set(this.goodsReportForm, 'materialEnglish', '')
            this.$set(this.goodsReportForm, 'purposeEnglish', '')       
            this.$set(this.goodsReportForm, 'materialChinese', '')
            this.$set(this.goodsReportForm, 'purposeChinese', '')       
        },
		// 回车
		keyupEnter(refname) {
			this.$nextTick(() => {
				this.$refs[refname].$children[1].blur()
				let index = this.$refs[refname].$parent.$children.indexOf(this.$refs[refname])
				let ref = this.$refs[refname].$parent.$children.find((item, i) => i > index && item.$options._componentTag == 'el-form-item' && !item.$children[1].disabled)
				if (ref) ref.$children[1].focus()
			})
		}, 
        async goodNameBlur(fromInput){
            // if(this.goodsReportForm[fromInput]){
            //     this.goodsReportForm[fromInput] = this.goodsReportForm[fromInput].trim()
            // }
            // if(fromInput == 'goodNameChinese'){
            //     this.unrulyGoods = this.checkUnrulyGoods(this.goodsReportForm.goodNameChinese)
            // }
            // let toInput = ''
            // let fromLang = 'en'
            // let toLang = 'zh'
            // if(fromInput.indexOf('English') != -1){
            //     toInput = fromInput.replace('English', 'Chinese')
            //     fromLang = 'en'
            //     toLang = 'zh'
            // }else{
            //     toInput = fromInput.replace('Chinese', 'English')                
            //     toLang = 'en'
            //     fromLang = 'zh'                
            // }
            // if((this.goodsReportForm[fromInput]) && (string.isEmpty(this.goodsReportForm[toInput]))){
            //     let fanyi = await this.$api.getfanyi()
            //     let res = await this.$api.translate(this.goodsReportForm[fromInput], fanyi.appKey, fanyi.appSecret, fromLang, toLang)
            //     if (res && res.trans_result && res.trans_result.length && res.trans_result[0].dst) {
            //         this.$set(this.goodsReportForm, toInput, res.trans_result[0].dst)
            //     }                
            // }
        },
        checkUnrulyGoods(value){
            if((value) && (value.trim())){
                let name = value.trim().toUpperCase()
                for(let item of this.unrulyGoodsList){
                    if(item.keyword){
                        if(item.keyword.startsWith('*') && item.keyword.endsWith('*')){
                            let keyword = item.keyword.replace(/\*/g, '');
                            console.log(keyword)
                            if(name.indexOf(keyword.toUpperCase()) >= 0){
                                return item
                            }
                        }else
                        if(item.keyword.startsWith('*')){
                            let keyword = item.keyword.substr(1)
                            if(name.endsWith(keyword.toUpperCase())){
                                return item
                            }
                        }else
                        if(item.keyword.endsWith('*')){
                            let keyword = item.keyword.substr(0, item.keyword.length - 1)
                            if(name.startsWith(keyword.toUpperCase())){
                                return item
                            }                            
                        }else{
                            if(item.keyword.toUpperCase() == name){
                                return item
                            }
                        }
                    }
                }
            }
            return null
        },       
        btnCancelDetailClick(){
            this.initGoodsReport()
            this.$emit('formCancel')
        },    
        btnSaveDetailClick(){
            if(string.isEmpty(this.goodsReportForm.goodNameEnglish) 
                && string.isEmpty(this.goodsReportForm.goodNameChinese) 
                && Number.isNaN(parseInt(this.goodsReportForm.number))
                && Number.isNaN(parseFloat(this.goodsReportForm.price))
                && Number.isNaN(parseFloat(this.goodsReportForm.totalPrice))
                && string.isEmpty(this.goodsReportForm.hsGoodCode)
                && string.isEmpty(this.goodsReportForm.materialEnglish)
                && string.isEmpty(this.goodsReportForm.purposeEnglish)){
                this.$message.error('请输入有效申报数据!');
                return
            }
            this.$emit("formSave", this.goodsReportForm)
            this.initGoodsReport()
        },
        btnSaveAsDetailClick(){
            if(string.isEmpty(this.goodsReportForm.goodNameEnglish) 
                && string.isEmpty(this.goodsReportForm.goodNameChinese) 
                && Number.isNaN(parseInt(this.goodsReportForm.number))
                && Number.isNaN(parseFloat(this.goodsReportForm.price))
                && Number.isNaN(parseFloat(this.goodsReportForm.totalPrice))
                && string.isEmpty(this.goodsReportForm.hsGoodCode)
                && string.isEmpty(this.goodsReportForm.materialEnglish)
                && string.isEmpty(this.goodsReportForm.purposeEnglish)){
                this.$message.error('请输入有效申报数据!');
                return
            }
            this.$emit("formSaveAs", this.goodsReportForm)
            this.initGoodsReport()
        },
        getGoodsReportData(){
            if(string.isEmpty(this.goodsReportForm.goodNameEnglish) 
                && string.isEmpty(this.goodsReportForm.goodNameChinese) 
                && Number.isNaN(parseInt(this.goodsReportForm.number))
                && Number.isNaN(parseFloat(this.goodsReportForm.price))
                && Number.isNaN(parseFloat(this.goodsReportForm.totalPrice))
                && string.isEmpty(this.goodsReportForm.hsGoodCode)
                && string.isEmpty(this.goodsReportForm.materialEnglish)
                && string.isEmpty(this.goodsReportForm.purposeEnglish)){
                    return null
            }else{
                let data = {...this.goodsReportForm}
                this.initGoodsReport()
                return data
            }            
        },
        numberCheck(){
            if(this.goodsReportForm.price){
                let arr = this.goodsReportForm.price.toString().split('.')
                if((arr.length == 1) || ((arr.length == 2) && (arr[1].length < 3))){
                    return true
                }
            }
            return false
        },
        numberPriceChanged(){
            let n = string.toFloat(this.goodsReportForm.number)
            let p = string.toFloat(this.goodsReportForm.price)
            if((n != NaN) && (p != NaN)){
                this.$set(this.goodsReportForm, 'totalPrice', string.toFloat(n * p, 2))
            }
        },
        hsGoodCodeBlur(){
            let code = this.goodsReportForm.hsGoodCode.replace(/[^0-9]/g,'')
            this.$set(this.goodsReportForm, 'hsGoodCode', code)
        },
        btnUnrulyGoodsClick(){
            this.$emit('unrulyGoodsSetting', null)
        },
        focusFormItem(name){
            if(window.chrome.webview){
                window.chrome.webview.postMessage('focus:' + name) 
            }
        },
        checkGoodsRecoPrefix(fieldName){
            let content = this.goodsReportForm[fieldName]
            let prefixArr = this.recoSetting.goodNameEnglish?this.recoSetting.goodNameEnglish.replace('：', ':').split(','):[]
            prefixArr = prefixArr.concat(this.recoSetting.goodNameChinese?this.recoSetting.goodNameChinese.replace('：', ':').split(','):[])
            prefixArr = prefixArr.concat(this.recoSetting.materialEnglish?this.recoSetting.materialEnglish.replace('：', ':').split(','):[])
            prefixArr = prefixArr.concat(this.recoSetting.purposeEnglish?this.recoSetting.purposeEnglish.replace('：', ':').split(','):[])
            prefixArr = prefixArr.concat(this.recoSetting.hsGoodCode?this.recoSetting.hsGoodCode.replace('：', ':').split(','):[]) 
            prefixArr = prefixArr.concat(this.recoSetting.materialChinese?this.recoSetting.materialChinese.replace('：', ':').split(','):[])     
            prefixArr = prefixArr.concat(this.recoSetting.purposeChinese?this.recoSetting.purposeChinese.replace('：', ':').split(','):[])                        
            for(let prefix of prefixArr){
                let keyword = prefix.trim()
                if(keyword){
                    if(content.toUpperCase().indexOf(keyword.toUpperCase()) >=0){
                        return true
                    }
                }
            }
        },        
        goodsRecognize(fieldName){            
            let content = this.formatFieldValue(fieldName)
            if((fieldName == 'goodNameChinese') && (content == '运费')){
                this.freightFeeDialogVisible = true
                return
            }
            if(this.checkGoodsRecoPrefix(fieldName)){
                this.$refs[fieldName + 'Reco'].parseContent(content)
                this.goodsRecoPop[fieldName] = true
            }else{
                if(fieldName == 'hsGoodCode'){
                    let code = this.goodsReportForm.hsGoodCode.replace(/[^0-9]/g,'')
                    this.$set(this.goodsReportForm, 'hsGoodCode', code)                    
                }else
                if(fieldName == 'goodNameChinese'){
                    //检查不合规
                    this.unrulyGoods = this.checkUnrulyGoods(this.goodsReportForm.goodNameChinese)
                }else
                if(fieldName.indexOf('English') != -1){
                    //去掉英文
                    this.$set(this.goodsReportForm, fieldName, content.replace(/[\u4e00-\u9fa5]/g, ''))
                }
                if((fieldName.indexOf('English') != -1) || (fieldName.indexOf('Chinese') != -1)){
                    this.translateField(fieldName)
                }
            }            
        }, 
        formatFieldValue(fieldName){
            let content = this.goodsReportForm[fieldName]
            if((content) && (content.trim())){
                content = content.replace('：', ':').trim()
                if(content.startsWith('"') && content.endsWith('"')){
                    content = content.substr(1, content.length - 2)
                }
                let prefixArr = this.recoSetting[fieldName]?this.recoSetting[fieldName].split(','):[]
                if(prefixArr.length > 0){
                    for(let prefix of prefixArr){
                        prefix = prefix.replace('：', ':') //中文冒号替换为英文冒号
                        if((prefix) && (content.toUpperCase().startsWith(prefix.toUpperCase()))){
                            content = content.substr(prefix.length)
                            break
                        }
                    }            
                }
            }else{
                content = ''
            }
            this.$set(this.goodsReportForm, fieldName, content)  
            return content
        },
        async translateField(fromInput){
            if(this.goodsReportForm[fromInput]){
                this.goodsReportForm[fromInput] = this.goodsReportForm[fromInput].trim()
            }
            if(fromInput == 'goodNameChinese'){
                this.unrulyGoods = this.checkUnrulyGoods(this.goodsReportForm.goodNameChinese)
            }
            let toInput = ''
            let fromLang = 'en'
            let toLang = 'zh'
            if(fromInput.indexOf('English') != -1){
                toInput = fromInput.replace('English', 'Chinese')
                fromLang = 'en'
                toLang = 'zh'
            }else{
                toInput = fromInput.replace('Chinese', 'English')                
                toLang = 'en'
                fromLang = 'zh'                
            }
            if((this.goodsReportForm[fromInput]) && (string.isEmpty(this.goodsReportForm[toInput]))){
                let fanyi = await this.$api.getfanyi()
                let res = await this.$api.translate(this.goodsReportForm[fromInput], fanyi.appKey, fanyi.appSecret, fromLang, toLang)
                if (res && res.data.trans_result && res.data.trans_result.length && res.data.trans_result[0].dst) {
                    this.$set(this.goodsReportForm, toInput, res.data.trans_result[0].dst)
                } 						
            }
        },        
        getRecognizedData(fieldName){
            let obj = this.$refs[fieldName + 'Reco'].getRecognizedData()
            let curFieldValue = ''
            for(let key in obj){
                let value = obj[key]
                if((value) && value.trim()){
                    value = value.trim()
                    if(key.toUpperCase().indexOf('ENGLISH') != -1){
                        //去掉中文
                        value = value.replace(/[\u4e00-\u9fa5]/g, '')
                    }                    
                    this.$set(this.goodsReportForm, key, value)
                    if(key == fieldName){
                        curFieldValue = value
                    }
                }
            }
            if(curFieldValue == ''){
                this.$set(this.goodsReportForm, fieldName, '')                
            }
            for(let key in obj){
                if(key.indexOf('English') != -1){
                    let cnValue = this.goodsReportForm[key.replace('English', 'Chinese')]
                    if((!cnValue) || (cnValue.trim() == '')){
                        this.translateField(key)
                    }
                }else
                if(key.indexOf('Chinese') != -1){
                    let enValue = this.goodsReportForm[key.replace('Chinese', 'English')]
                    if((!enValue) || (enValue.trim() == '')){
                        this.translateField(key)
                    }
                }                
            }
            this.goodsRecoPop[fieldName] = false        
        },                       
        freightFeeDialogConfirm(){
            this.goodsReportForm.goodNameEnglish = 'FREIGHT FEE'
            this.goodsReportForm.number = '1'
            this.goodsReportForm.materialEnglish = '.'
            this.goodsReportForm.materialChinese = '.'
            this.goodsReportForm.purposeEnglish = '.'
            this.goodsReportForm.purposeChinese = '.'
            this.goodsReportForm.hsGoodCode = '0000000000'
            this.freightFeeDialogVisible = false
        }
    },
	components: {
        goodsRecoComp,
    }
}
</script>

<style scoped>
.numberInput /deep/ .el-input__inner {
  color: red;
}
.numberInputBlack /deep/ .el-input__inner {
  color: black;
}
</style>
